
const milestones = [
  "Hire Head of Corp Dev / M&A",
  "Acquire 1-2 firms via equity swap (zero cash)",
  "Deploy COSX + Xeni across acquired operations",
  "Generate before/after P&L transformation data",
  "Reach £25K+ MRR from firm operations",
  "Package playbook for £3-5M Series A",
];

const terms = [
  { label: "Pre-Money", value: "£7.5M" },
  { label: "Dilution", value: "~9%" },
  { label: "Instrument", value: "EIS" },
  { label: "Min Ticket", value: "£25K" },
  { label: "Runway", value: "12 Mo" },
];

const funds = [
  { label: "Product & R&D", pct: 41, color: "var(--color-accent)" },
  { label: "GTM & Sales", pct: 33, color: "#818cf8" },
  { label: "Legal & Ops", pct: 26, color: "#a5b4fc" },
];

export function TheAskSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-5">
        <h2 className="text-[32px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
          £750K Seed Round
        </h2>
        <p className="text-[14px] leading-relaxed text-[var(--color-fg-secondary)] font-light">
          Prove the roll-up unit economics. Generate the data that unlocks a £3-5M Series A.
        </p>
      </div>

      <div className="flex flex-row gap-6 flex-grow mb-4 items-start">
        {/* Left: Milestones timeline */}
        <div className="flex-1">
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)]">
            12-Month Milestones
          </div>
          <div className="pl-5">
            <div className="flex flex-col gap-3">
              {milestones.map((m, i) => (
                <div key={m} className="flex items-start gap-3 relative">
                  <div className="absolute left-[-17px] top-[5px] w-2.5 h-2.5 rounded-full shrink-0 z-[1] bg-[var(--color-accent)]" />
                  {i < milestones.length - 1 && <div className="absolute left-[-13px] top-[15px] bottom-[-16px] w-px bg-[var(--color-border)]" />}
                  <span className="text-[12px] text-[var(--color-fg-secondary)]">{m}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right: Pie chart */}
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)] w-full">
            Use of Funds
          </div>
          <div className="flex items-center gap-6">
            <div
              className="w-[160px] h-[160px] rounded-full shrink-0"
              style={{ background: "conic-gradient(var(--color-accent) 0% 41%, #818cf8 41% 74%, #a5b4fc 74% 100%)" }}
            />
            <div className="flex flex-col gap-3">
              {funds.map((f) => (
                <div key={f.label} className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-sm shrink-0" style={{ background: f.color }} />
                  <div>
                    <div className="text-[14px] font-bold">{f.pct}%</div>
                    <div className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">{f.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom: Investment terms inline + border-b */}
      <div className="mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <div className="flex justify-between font-[family-name:var(--font-mono)] text-[11px]">
          {terms.map((t) => (
            <div key={t.label} className="text-center">
              <div className="text-[16px] font-bold text-[var(--color-fg)] font-[family-name:var(--font-heading)]">{t.value}</div>
              <div className="text-[var(--color-fg-tertiary)] uppercase tracking-wider">{t.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
